import { render, staticRenderFns } from "./BankingsEdit.vue?vue&type=template&id=304fc8d4&"
import script from "./BankingsEdit.vue?vue&type=script&lang=js&"
export * from "./BankingsEdit.vue?vue&type=script&lang=js&"
import style0 from "./BankingsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports